module.exports = __webpack_public_path__ + "img/hook_PEWAG_WLHW_4.d826748a.png";